import React from 'react'

import { Link } from 'react-router-dom'

import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import GitHubIcon from '@material-ui/icons/GitHub';


const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  toolbar: theme.mixins.toolbar,
}));

function GeneralLayout({ children }) {

  const classes = useStyles();
  const loggedIn = true;

  const userName = "plasmatech8"

  return (
    <div>
      <AppBar>
          <Toolbar>

          <MenuItem component={Link} to="/">
            <Typography variant="h6">GitShares</Typography>
          </MenuItem>

          {/* Search field */}
          {/* <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div> */}

          {/* Spacer */}
          <Box flex="1"/>

          {/* Login field OR Use icon */}
          {loggedIn ? (
            <>
              {/* Github button */}
              <IconButton color="inherit"><GitHubIcon fontSize="large"/></IconButton>

              {/* User button */}
              <IconButton component={Link} to={`/${userName}`} color="inherit">
                <Avatar alt="Me" src={"https://avatars3.githubusercontent.com/u/40431112?v=4"} >
                  Me
                </Avatar>
              </IconButton>
            </>
          ) : (
            <>
            <Button color="inherit" variant="outlined" startIcon={<GitHubIcon/>}>
              Login
            </Button>
            </>
          )
        }
        </Toolbar>
      </AppBar>
      <Box marginTop={8}>
        <div className={classes.toolbar}>
          { children }

        </div>
      </Box>
    </div>
  )
}

export default GeneralLayout
